import UpdatePortalBanner from 'components/common/UpdatePortalBanner';
import { PathName } from 'enums/pathName';
import { Outlet, RouteObject } from 'react-router';
import { lazyWithRetries, SuspenseWrapper } from 'utils/common/lazy';

import ErrorPage from './ErrorPage/ErrorPage';
import { protectedRoutesConfig } from './protectedRoutes.settings';

const ProtectedRoute = lazyWithRetries(() => import('./ProtectedRoute'));
const Login = lazyWithRetries(() => import('../pages/Login'));
const ExternalVideoCall = lazyWithRetries(() => import('../pages/ExternalVideoCall'));

const RootLayout = () => {
  return (
    <>
      <UpdatePortalBanner />
      <Outlet />
    </>
  );
};

export const routerConfig: RouteObject[] = [
  { element: <SuspenseWrapper children={<Login />} />, errorElement: <ErrorPage />, index: true },
  {
    children: protectedRoutesConfig,
    element: (
      <SuspenseWrapper>
        <ProtectedRoute>
          <RootLayout />
        </ProtectedRoute>
      </SuspenseWrapper>
    ),
    errorElement: <ErrorPage />,
    path: ''
  },
  {
    element: (
      <SuspenseWrapper>
        <ExternalVideoCall />
      </SuspenseWrapper>
    ),
    path: PathName.ExternalVideoCall
  }
];
